import {ScaleConfig} from "../../../../../base-konva/types";

export default class ConfigHelper {
	public static isScaleSet(config: ScaleConfig): boolean {
		return config.scale != null;
	}
}
